import {
  GAME_SCROLL_SAVE_SUCCESS,
  GAME_SCROLL_CLEAR,
} from '../constants/game';

const initState = {
  at: 0,
};

const game = (state = initState, payload = {}) => {
  switch (payload.type) {
    case GAME_SCROLL_SAVE_SUCCESS:
      return { ...state, at: payload.at };
    case GAME_SCROLL_CLEAR:
      return { ...state, at: 0 };
    default:
      return state;
  }
};

export default game;
